export default __webpack_public_path__ + "static/media/oscer-pres-rigors.8adf9742.svg";